export default {
  // Navbar
  search_placeholder: "Que cherchez-vous ?",
  publish_ad: "Publier une annonce",
  sign_in: "Se connecter",
  logout: "Déconnexion",
  profile: "Mon Profil",
  my_ads: "Mes Annonces",
  admin: "Administration",
  messages: "Messages",
  home: "Accueil",
  member: "Membre",

  // Home
  categories_title: "Catégories Principales",
  latest_ads: "Dernières annonces",
  sell_cta_title: "Vous avez quelque chose à vendre ?",
  sell_cta_desc: "Publiez votre annonce gratuitement et touchez des milliers d'acheteurs en Algérie.",
  search_btn: "Rechercher",
  load_more: "Voir plus d'annonces",
  loading: "Chargement...",
  no_ads: "Aucune annonce pour le moment.",

  // Categories
  cat_cars: "Voitures",
  cat_realestate: "Immobilier",
  cat_phones: "Téléphones",
  cat_jobs: "Emplois",
  cat_bikes: "Motos",
  cat_electronics: "Électronique",
  cat_vehicles: "Véhicules",
  cat_furniture: "Meubles",
  cat_fashion: "Mode",
  cat_sports: "Sports",
  cat_animals: "Animaux",
  cat_services: "Services",
  all_categories: "Toutes les catégories",

  // Product card
  price_on_request: "Prix à négocier",
  today: "Aujourd'hui",
  yesterday: "Hier",
  country: "Algérie",
  currency: "DA",

  // Listing pages
  items_found: "articles",
  search_direct: "Rechercher",
  showing: "Affichage de",
  of: "sur",
  results: "résultats",
  search_results_for: "Résultats pour",

  // Footer
  footer_desc: "9achna — La marketplace de confiance en Algérie pour acheter et vendre seconde main entre particuliers.",
  quick_links: "Liens utiles",
  categories: "Catégories",
  contact_us: "Contact",
  about: "À propos",
  help: "Centre d'aide",
  privacy: "Politique de confidentialité",
  terms: "Conditions d'utilisation",
  made_with: "Fait avec",
  in_country: "en Algérie",
  sell_items: "Publier une annonce",

  // Sell / SellForm
  sell_hero_title: "Commencez à vendre aujourd'hui",
  sell_hero_desc: "Touchez des milliers d'acheteurs et vendez vos articles rapidement",
  sell_free_label: "Gratuit",
  sell_what_selling: "Que vendez-vous ?",
  sell_choose_category: "Choisissez une catégorie pour commencer",
  sell_change_category: "Choisir une autre catégorie",
  sell_feature_photos: "Ajout facile",
  sell_feature_photos_desc: "Ajoutez vos photos en quelques secondes",
  sell_feature_fast: "Vente rapide",
  sell_feature_fast_desc: "Atteignez des acheteurs instantanément",
  sell_feature_secure: "Sécurisé",
  sell_feature_secure_desc: "Transactions sûres et fiables",

  // SellForm
  post_ad_title: "Publier votre annonce",
  post_ad_submit: "Publier l'annonce",
  sell_change: "Modifier",
  photos_label: "Photos",
  add_photo: "Ajouter une photo",
  photos_hint: "Ajoutez au moins 2 photos nettes (12 maximum). La première sera la photo principale.",
  posting_ad: "Publication en cours...",

  // Validation
  validation_error: "Erreur de validation",
  err_title_required: "Veuillez ajouter un titre",
  err_brand_required: "Veuillez choisir la marque",
  err_title_short: "Le titre doit contenir au moins 3 caractères",
  err_title_long: "Le titre ne doit pas dépasser 100 caractères",
  err_desc_required: "Veuillez ajouter une description",
  err_desc_short: "La description doit contenir au moins 10 caractères",
  err_desc_long: "La description est trop longue",
  err_location_required: "Veuillez ajouter une adresse ou sélectionner votre position",
  err_image_required: "Ajoutez au moins 2 photos",
  err_image_max: "Maximum 12 photos autorisées",
  err_name_required: "Veuillez ajouter votre nom",
  err_price_required: "Veuillez indiquer un prix",
  err_price_invalid: "Veuillez entrer un prix valide",
  err_price_max: "Le prix ne peut pas dépasser 100 000 000 DA",
  login_required: "Connexion requise",
  login_required_desc: "Vous devez être connecté pour publier une annonce.",
  post_ad_error: "Échec de la publication. Veuillez réessayer.",
  error: "Erreur",

  // Price field
  price_label: "Prix",
  price_enter: "Saisissez le prix",
  price_hint: "Fixez un prix compétitif pour vendre plus vite.",

  // Details / Addetails (SellForm sub-components)
  ad_details: "Détails de l'annonce",
  ad_title: "Titre de l'annonce",
  ad_title_placeholder: "Entrez un titre accrocheur",
  ad_title_hint: "Soyez précis et descriptif pour attirer les acheteurs",
  ad_description: "Description",
  ad_desc_placeholder: "Décrivez votre article : état, couleur, taille, défauts éventuels...",
  ad_desc_hint: "Incluez les détails importants pour les acheteurs",
  your_details: "Vos informations",
  your_name: "Nom",
  phone_number: "Numéro de téléphone",

  // SelectLocation
  loc_title: "Localisation",
  loc_select_tab: "Choisir la ville",
  loc_current_tab: "Position actuelle",
  loc_select_wilaya: "Choisir la wilaya",
  loc_select_commune: "Choisir la commune",
  loc_enter_area: "Quartier / précisions (optionnel)",
  loc_detecting: "Détection de votre position...",
  loc_wilaya_label: "Wilaya",
  loc_commune_label: "Commune",
  loc_area_label: "Quartier",
  loc_postcode_label: "Code postal",

  // PreviewAd
  preview_available: "Disponible",
  preview_seller_info: "INFORMATIONS VENDEUR",
  preview_seller_label: "Vendeur",
  preview_chat_seller: "Contacter le vendeur",
  preview_remove_ad: "Supprimer l'annonce",
  preview_removing: "Suppression...",
  preview_location: "Localisation",
  preview_safety_tips: "Conseils de sécurité",
  preview_safety_tip1: "Rencontrez-vous dans un lieu public sûr",
  preview_safety_tip2: "Vérifiez l'article avant de payer",
  preview_safety_tip3: "Ne payez pas à l'avance",

  // Chat safety banner
  chat_safety_title: "Conseils de sécurité",
  chat_safety_1: "Ne partagez jamais vos informations personnelles (téléphone, adresse, RIB)",
  chat_safety_2: "Ne payez jamais à l'avance — payez uniquement en main propre",
  chat_safety_3: "Rencontrez-vous dans un lieu public et sécurisé",
  chat_safety_4: "Méfiez-vous des offres trop belles pour être vraies",
  chat_safety_dismiss: "Compris",
  preview_verified: "Vendeur vérifié",
  preview_secure_tx: "Transaction sécurisée",
  preview_removed_title: "Annonce supprimée",
  preview_removed_desc: "L'annonce a été supprimée avec succès.",
  preview_remove_error: "Une erreur s'est produite lors de la suppression.",
  preview_photos: "photos",
  preview_description: "Description",
  days_ago: "jours",

  // Condition (état)
  condition_label: "État",
  condition_new_tag: "Neuf avec étiquette",
  condition_new_no_tag: "Neuf sans étiquette",
  condition_very_good: "Très bon état",
  condition_good: "Bon état",
  condition_fair: "État correct",
  condition_parts: "Pour pièces",

  // Color (couleur)
  color_label: "Couleur",
  color_optional: "(optionnel)",

  // Delivery
  delivery_label: "Livraison",
  delivery_available: "Livraison disponible",
  delivery_not_available: "Pas de livraison",
  delivery_switch: "Proposer la livraison (optionnel)",

  // Last seen
  online_now: "En ligne",
  min_ago: "min",
  hours_ago: "h",

  // Offer
  offer_btn: "Faire une offre",
  offer_modal_title: "Faire une offre",
  offer_price_label: "Votre offre (DA)",
  offer_price_placeholder: "Ex: 5 000",
  offer_message_label: "Message (optionnel)",
  offer_message_placeholder: "Décrivez votre offre...",
  offer_send: "Envoyer l'offre",
  offer_sending: "Envoi...",
  offer_sent_title: "Offre envoyée !",
  offer_sent_desc: "Le vendeur recevra votre offre et vous contactera.",
  offer_error: "Impossible d'envoyer l'offre.",

  // NotFound
  not_found_title: "Page introuvable",
  not_found_desc: "La page que vous cherchez n'existe pas ou a été déplacée.",
  back_home: "Retour à l'accueil",
  search_items: "Parcourir les annonces",

  // Loading
  please_wait: "Veuillez patienter...",

  // Myads
  myads_title: "Mes Annonces",
  myads_subtitle: "Gérez et suivez vos annonces actives",
  myads_listing: "annonce",
  myads_listings: "annonces",
  myads_active: "Actif",
  myads_view: "Voir",
  myads_edit: "Modifier",
  myads_delete: "Supprimer",
  myads_deleted: "Annonce supprimée",
  myads_delete_error: "Impossible de supprimer l'annonce.",
  myads_load_more: "Voir plus",
  myads_empty_title: "Vous n'avez pas encore d'annonces",
  myads_empty_desc: "Publiez votre première annonce et touchez des milliers d'acheteurs.",
  myads_publish: "Publier une annonce",
  nav_home: "Accueil",

  // EditAd
  edit_ad_title: "Modifier l'annonce",
  edit_save: "Enregistrer les modifications",
  edit_saving: "Enregistrement...",
  edit_saved: "Annonce mise à jour avec succès",
  edit_save_error: "Impossible de mettre à jour l'annonce.",
  edit_cancel: "Annuler",
  edit_photos: "Photos",
  edit_photos_hint: "Appuyez sur × pour supprimer · Max 12 photos",
  edit_photos_add: "Ajouter des photos",
  edit_location_section: "Localisation",
  edit_location_change: "Changer la localisation",
  edit_location_current: "Localisation actuelle",
  edit_owner_name: "Nom du vendeur",
  edit_brand: "Marque",
  edit_size_label: "Taille",
  edit_color_custom: "Autre couleur (saisie libre)...",
  edit_min_image: "Au moins 2 photos sont requises",
  edit_uploading: "Téléchargement des photos...",

  // EditAd / SellForm — per-category fields
  field_select_placeholder: "Sélectionner...",
  field_sport_type:  "Type de sport",
  field_model:       "Modèle",
  field_capacity:    "Capacité / Stockage",
  field_format:      "Format",
  field_author:      "Auteur / Artiste",
  field_year:        "Année",
  field_material:    "Matière",
  field_dimensions:  "Dimensions",

  // PreviewAd new
  preview_added: "Ajouté",
  preview_show_more: "voir plus",
  preview_show_less: "voir moins",

  // SearchNotFound
  search_no_results: "Aucun résultat trouvé",
  search_no_results_desc: "Essayez d'autres mots-clés ou élargissez votre recherche.",
  search_again_placeholder: "Rechercher autre chose...",

  // Auth — Login / Register
  login_welcome: "Bienvenue !",
  register_title: "Créer un compte",
  login_subtitle: "Connectez-vous à votre compte",
  register_subtitle: "Rejoignez des milliers d'acheteurs et de vendeurs",
  email_label: "Adresse e-mail",
  password_label: "Mot de passe",
  forgot_password: "Mot de passe oublié ?",
  sign_in_btn: "Se connecter",
  full_name: "Nom complet",
  confirm_password: "Confirmer le mot de passe",
  create_account: "Créer un compte",
  no_account: "Vous n'avez pas de compte ?",
  create_one: "S'inscrire",
  has_account: "Déjà un compte ?",
  or_email: "ou avec e-mail",
  email_not_found: "Adresse e-mail introuvable",
  incorrect_password: "Mot de passe incorrect",
  user_exists: "Un compte existe déjà avec cet e-mail",
  signing_in: "Connexion en cours...",
  creating_account_loading: "Création en cours...",
  account_created: "Compte créé !",
  account_created_desc: "Vous pouvez maintenant vous connecter.",
  go_to_login: "Aller à la connexion",
  passwords_no_match: "Les mots de passe ne correspondent pas",
  password_too_short: "Le mot de passe doit contenir au moins 6 caractères",
  otp_invalid: "Veuillez saisir le code à 4 chiffres complet",
  otp_sent: "Code envoyé",
  otp_sent_desc: "Un code de vérification a été envoyé à",
  forgot_password_title: "Mot de passe oublié",
  forgot_password_hint: "Entrez votre e-mail et nous vous enverrons un code de réinitialisation.",
  enter_otp: "Saisir le code",
  new_password: "Nouveau mot de passe",
  send_otp_btn: "Envoyer le code",
  reset_password_btn: "Réinitialiser",
  resend_otp: "Renvoyer le code",
  back_to_login: "Retour à la connexion",
  back: "Retour",
  password_reset_success: "Mot de passe réinitialisé !",
  now_sign_in: "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",

  // Chat
  chat_inbox: "Boîte de réception",
  chat_no_messages: "Aucun message",
  chat_no_messages_desc: "Commencez une conversation pour voir vos messages ici",
  chat_conversations: "conversation(s)",
  chat_type_message: "Écrivez un message...",
  chat_delete: "Supprimer la conversation",
  chat_see_product: "Voir l'article",
  chat_deleted: "Conversation supprimée",
  chat_not_found: "Conversation introuvable",
  chat_select: "Vos messages",
  chat_select_desc: "Sélectionnez une conversation dans la liste pour commencer",
  chat_cannot_send: "Vous ne pouvez pas envoyer ce message",

  // Category filters
  filter_filters: "Filtres",
  filter_sort: "Trier par",
  filter_sort_newest: "Plus récents",
  filter_sort_price_asc: "Prix croissant",
  filter_sort_price_desc: "Prix décroissant",
  filter_price: "Prix (DA)",
  filter_price_min: "Min",
  filter_price_max: "Max",
  filter_condition: "État",
  filter_delivery: "Livraison disponible",
  filter_wilaya: "Wilaya",
  filter_apply: "Appliquer",
  filter_reset: "Réinitialiser",
  filter_reset_all: "Effacer les filtres",
  filter_category: "Catégorie",
  filter_subcategory: "Sous-catégorie",
  filter_brand: "Marque",
  filter_size: "Taille",
  filter_color: "Couleur",

  // Product status
  status_available: "Disponible",
  status_reserved: "Réservé",
  status_sold: "Vendu",
  status_sold_notice: "Cet article a déjà été vendu.",
  reserve_btn: "Demander la réservation",
  reserve_cancel: "Annuler la réservation",
  reserve_success: "Produit réservé !",
  reserve_success_desc: "Le vendeur a été notifié.",
  reserve_error: "Impossible d'effectuer cette action.",
  reserve_request_sent: "Demande envoyée",
  reserve_request_sent_desc: "Le vendeur doit approuver votre demande.",
  reserve_request_cancelled: "Demande annulée",
  reserve_request_cancel: "Retirer ma demande",
  reserve_pending_buyer: "En attente d'approbation du vendeur",
  reserve_pending_seller: "Demande de réservation reçue",
  reserve_pending_other: "Une réservation est en cours de traitement",
  reserve_approve: "Approuver",
  reserve_reject: "Refuser",
  reserve_approved: "Réservation confirmée",
  reserve_rejected: "Demande refusée",
  status_reserved_me: "Réservé pour moi ✓",
  mark_sold_btn: "Marquer comme vendu",
  mark_available_btn: "Remettre en vente",
  mark_sold_success: "Article marqué comme vendu",
  mark_available_success: "Article remis en vente",

  // Report message
  report_btn: "Signaler",
  report_title: "Signaler ce message",
  report_reason_label: "Raison du signalement",
  report_send: "Envoyer le signalement",
  report_sent: "Signalement envoyé",
  report_sent_desc: "Notre équipe examinera ce message.",
  report_error: "Impossible d'envoyer le signalement.",

  // Profile page
  profile_my_profile: "Mon Profil",
  profile_my_listings: "Mes Annonces",
  profile_listings_manage: "Gérez et suivez vos annonces",
  profile_edit_btn: "Modifier le profil",
  profile_account_active: "Actif",
  profile_member_since: "Membre depuis",
  profile_share: "Partager le profil",
  profile_username_label: "Nom d'utilisateur",
  profile_user_listings: "Annonces de",
  profile_items_listed: "annonce(s) publiée(s)",
  profile_load_more: "Voir plus d'annonces",

  // Auth — username
  username_label: "Nom d'utilisateur",
  username_placeholder: "ex: ahmed_dz",
  username_hint: "Lettres, chiffres et _ uniquement.",
  username_taken: "Ce nom d'utilisateur est déjà pris",
  identifier_label: "E-mail ou nom d'utilisateur",
  identifier_placeholder: "exemple@email.com ou nom_utilisateur",

  // EditProfile page
  edit_profile_title: "Modifier le profil",
  edit_profile_view: "Voir le profil",
  edit_profile_basic_info: "Informations de base",
  edit_profile_contact_info: "Coordonnées",
  edit_profile_picture: "Photo de profil",
  edit_profile_full_name: "Nom complet",
  edit_profile_email: "Adresse e-mail",
  edit_profile_phone: "Numéro de téléphone",
  edit_profile_save: "Enregistrer",
  edit_profile_cancel: "Annuler",
  edit_profile_saving: "Enregistrement...",
  edit_profile_verified: "Vérifié",
  edit_profile_not_verified: "Non vérifié",
  edit_verify_title: "Vérifier votre e-mail",
  edit_verify_enter_code: "Saisir le code",
  edit_verify_subtitle: "Sécurisez votre compte",
  edit_verify_code_sent: "Code envoyé à votre e-mail",
  edit_verify_send_btn: "Envoyer le code de vérification",
  edit_verify_sending: "Envoi...",
  edit_verify_code_label: "Code à 4 chiffres",
  edit_verify_verifying: "Vérification...",
  edit_verify_resend: "Renvoyer",
  edit_verify_no_code: "Vous n'avez pas reçu le code ?",
  edit_verify_change_email: "Changer l'e-mail",

  // AdSuccess page
  adsuccess_title: "Annonce publiée !",
  adsuccess_subtitle: "Votre annonce sera visible sous peu.",
  adsuccess_step1: "Les acheteurs peuvent maintenant trouver votre article.",
  adsuccess_step2: "Répondez rapidement aux messages pour vendre plus vite.",
  adsuccess_step3: "Convenez d'un lieu de rencontre sécurisé pour l'échange.",
  adsuccess_view_ads: "Voir mes annonces",
  adsuccess_post_another: "Publier une autre annonce",
  adsuccess_share: "Partager 9achna",

  // ── Hero Home ─────────────────────────────────────────────
  hero_badge:         "Achat et vente de vêtements seconde main",
  hero_title_line1:   "Achète et vends",
  hero_title_line2:   "tes vêtements en Algérie",
  hero_subtitle:      "Vide-dressing entre particuliers — femme, homme, enfant.",
  hero_subtitle_bold: "Partout en Algérie.",
  hero_cta_sell:      "Commencer à vendre",
  hero_cta_how:       "Découvrir comment ça marche →",
  hero_trust_free:    "Gratuit",
  hero_trust_delivery:"Livraison",
  hero_trust_secure:  "Sécurisé",

  // ── Comment ça marche ─────────────────────────────────────
  hiw_badge:            "9achna — Guide complet",
  hiw_hero_title:       "Comment ça marche ?",
  hiw_hero_subtitle:    "Acheter et vendre sur 9achna est simple, rapide et gratuit. Voici tout ce que vous devez savoir.",
  hiw_start_sell:       "Commencer à vendre",
  hiw_browse:           "Parcourir les articles",
  hiw_see_articles:     "Voir les articles",

  hiw_sell_label:       "Vous vendez ?",
  hiw_sell_title:       "4 étapes pour vendre",
  hiw_sell_subtitle:    "De la photo à l'encaissement — tout en quelques minutes.",

  hiw_sell_s1_title:    "Prenez une photo",
  hiw_sell_s1_desc:     "Photographiez votre article avec votre téléphone. Pas besoin de studio — une bonne lumière naturelle suffit. Plusieurs photos augmentent vos chances de vendre.",
  hiw_sell_s1_tip:      "💡 Astuce : photographiez sur fond blanc ou neutre",
  hiw_sell_s2_title:    "Publiez en 2 minutes",
  hiw_sell_s2_desc:     "Choisissez la catégorie, remplissez le titre, la taille, l'état et le prix. Votre annonce est en ligne instantanément et visible par des milliers d'acheteurs en Algérie.",
  hiw_sell_s2_tip:      "💡 Astuce : un titre précis attire plus de clics",
  hiw_sell_s3_title:    "Discutez avec l'acheteur",
  hiw_sell_s3_desc:     "Les acheteurs intéressés vous contactent directement par messagerie. Répondez rapidement pour maximiser vos ventes. Vous pouvez négocier le prix directement.",
  hiw_sell_s3_tip:      "💡 Astuce : répondre en moins d'1h triple les ventes",
  hiw_sell_s4_title:    "Vendez & encaissez",
  hiw_sell_s4_desc:     "Organisez la remise en main propre dans un endroit public, ou proposez la livraison. Une fois l'échange fait, l'article est vendu !",
  hiw_sell_s4_tip:      "💡 Astuce : préférez les lieux publics pour la sécurité",

  hiw_buy_label:        "Vous achetez ?",
  hiw_buy_title:        "Trouver la perle rare",
  hiw_buy_subtitle:     "Des milliers d'articles à petits prix, partout en Algérie.",

  hiw_buy_s1_title:     "Recherchez l'article",
  hiw_buy_s1_desc:      "Parcourez les catégories ou utilisez la barre de recherche. Filtrez par taille, état, prix ou wilaya pour trouver exactement ce que vous cherchez.",
  hiw_buy_s2_title:     "Ajoutez en favori",
  hiw_buy_s2_desc:      "Sauvegardez les articles qui vous intéressent dans vos favoris pour les retrouver facilement et les comparer avant d'acheter.",
  hiw_buy_s3_title:     "Contactez le vendeur",
  hiw_buy_s3_desc:      "Cliquez sur 'Contacter le vendeur' pour envoyer un message. Posez vos questions, négociez le prix et organisez la rencontre.",
  hiw_buy_s4_title:     "Récupérez votre article",
  hiw_buy_s4_desc:      "Retrouvez le vendeur en main propre ou recevez l'article par livraison. Vérifiez l'article avant de payer.",

  hiw_tips_title:       "Conseils & bonnes pratiques",
  hiw_tips_subtitle:    "Pour une expérience sûre et agréable sur 9achna.",

  hiw_tip1_title:       "Sécurité avant tout",
  hiw_tip1_p1:          "Rencontrez toujours dans un lieu public (café, centre commercial)",
  hiw_tip1_p2:          "Vérifiez l'article avant de payer",
  hiw_tip1_p3:          "Ne partagez jamais vos coordonnées bancaires",
  hiw_tip1_p4:          "Signalez tout comportement suspect",

  hiw_tip2_title:       "La livraison",
  hiw_tip2_p1:          "Disponible via les services de livraison algériens",
  hiw_tip2_p2:          "Négociez qui prend en charge les frais",
  hiw_tip2_p3:          "Prenez des photos de l'emballage avant envoi",
  hiw_tip2_p4:          "Utilisez un suivi de colis si possible",

  hiw_tip3_title:       "Conseils de vente",
  hiw_tip3_p1:          "Photos claires = plus de ventes",
  hiw_tip3_p2:          "Prix juste = vente plus rapide",
  hiw_tip3_p3:          "Décrivez honnêtement l'état de l'article",
  hiw_tip3_p4:          "Répondez rapidement aux messages",

  hiw_faq_title:        "Questions fréquentes",
  hiw_faq_q1:           "Est-ce que c'est gratuit ?",
  hiw_faq_a1:           "Oui, publier une annonce sur 9achna est 100% gratuit. Pas de commission, pas d'abonnement.",
  hiw_faq_q2:           "Comment fixer le bon prix ?",
  hiw_faq_a2:           "Cherchez des articles similaires sur 9achna pour vous faire une idée. En général, les vêtements de seconde main se vendent entre 30% et 60% du prix neuf selon leur état.",
  hiw_faq_q3:           "Comment se passe la livraison ?",
  hiw_faq_a3:           "La livraison est organisée directement entre vendeur et acheteur via les services de livraison algériens (Yalidine, Zaki, etc.). Les frais sont à négocier entre les deux parties.",
  hiw_faq_q4:           "Que faire si j'ai un problème ?",
  hiw_faq_a4:           "Utilisez le bouton 'Signaler' sur l'annonce ou contactez-nous via la page Contact. Notre équipe traite les signalements rapidement.",
  hiw_faq_q5:           "Puis-je vendre depuis n'importe quelle wilaya ?",
  hiw_faq_a5:           "Oui ! 9achna couvre toutes les 58 wilayas d'Algérie. Votre annonce est visible par tous les acheteurs du pays.",

  hiw_cta_title:        "Prêt à vous lancer ?",
  hiw_cta_subtitle:     "Rejoignez la communauté 9achna et donnez une 2ème vie à vos vêtements.",
  hiw_sell_now:         "Vendre maintenant",

  // Achat & réservation
  buy_btn: "Acheter",
  buy_intent_message: "Bonjour, je souhaite acheter cet article. Est-il toujours disponible ?",
  reserve_for_buyer: "Réserver pour cet acheteur",
  reserve_for_buyer_done: "Article réservé pour cet acheteur",
  show: "Afficher",
  hide: "Masquer",
};
